export default function (dataSet, fieldKey) {
  const labels = [];
  const data = [];
  (dataSet?.[fieldKey] || []).forEach((x) => {
    labels.push(x.orderstatus);
    data.push(x.ordercount);
  });
  return {
    hoverBackgroundColor: "red",
    hoverBorderWidth: 10,
    labels,
    datasets: [
      {
        backgroundColor: [
          "#FF4500",
          "#007D69",
          "#017EFA",
          "#2DDF89",
          "#ff0000",
          "#E374F2",
          "#EC4E0F",
          "var(--primary)",
          "#5E3FBE",
          "#0000FF",
          "#00BFFF",
          "#ADD8E6",
        ],
        data,
      },
    ],
  };
}
